import moment from "moment";
import { pointsConfig } from "../../pointsConfig";
import { milesPointUserRank } from "../../controllers/pointsController";

export function leaderboardTableData(data) {
  const rankStatus = milesPointUserRank(data?.totalAmount || 0);
  return [
    {
      elements: [
        {
          type: "text",
          value: String(data?.rank),
        },
      ],
      value: "",
      width: "md:w-[5%]",
    },
    {
      elements: [
        {
          type: "text",
          value: data?.companyName,
        },
      ],
      value: "",
      width: "md:w-[20%]",
    },
    {
      elements: [
        {
          render: () => {
            return (
              <div className="flex items-center gap-2">
                <img src={rankStatus.icon} className="w-8 h-8 object-contain" />
                <span>{rankStatus.label}</span>
              </div>
            );
          },
        },
      ],
      value: "",
      width: "md:w-[20%]",
    },
    // {
    //   elements: [
    //     {
    //       type: "text",
    //       value: "Nora",
    //     },
    //   ],
    //   value: "",
    //   width: "md:w-[10%]",
    // },
    // {
    //   elements: [
    //     {
    //       type: "text",
    //       value: "405",
    //     },
    //   ],
    //   value: "",
    //   width: "md:w-[10%]",
    // },
    {
      elements: [
        {
          type: "text",
          value: (data?.totalAmount || "")?.toLocaleString(),
        },
      ],
      value: "",
      width: "md:w-[10%]",
    },
    // {
    //   elements: [
    //     {
    //       type: "text",
    //       value: "₦234,900",
    //     },
    //   ],
    //   value: "",
    //   width: "md:w-[10%]",
    // },
    {
      elements: [
        {
          type: "text",
          value: moment(data?.updatedAt).format("YYYY/MM/DD"),
        },
        {
          type: "title",
          value: moment(data?.updatedAt).format("hh:mm A"),
        },
      ],
      value: "",
      width: "md:w-[10%]",
    },
  ];
}
